// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.modal-header {
  display: flex;
  justify-content: center;
}



.pricing-card {
  width: '18rem';
  border-radius: 8px;
  height: 250px;
  position: relative;
  overflow-y: auto;
  padding: 16px;
  cursor: pointer;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  background: linear-gradient(to bottom, #aacedd, white);
  transition: height 0.3s ease;

  scrollbar-width: none;

}

.pricing-card::-webkit-scrollbar {
  width: 0;
}

/* .pricing-card:hover{
  scrollbar-width: thin;
} */

/* .pricing-card:hover::webkit-scrollbar{
  width: 6px;
} */

.pricing-card:hover::-webkit-scrollbar-thumb {
  background-color: rgba(0, 0, 0, 0.3);
  border-radius: 4px;
}


.price-details {
  position: relative;
  overflow: hidden;
}


.pricing-card::after {
  content: '';
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 40px;
  background: linear-gradient(to bottom, transparent, rgba(255, 255, 255, 1));
  pointer-events: none;
  transition: opacity 0.2s ease;
}

.pricing-card.scrolled::after {
  opacity: 0;
}

.see-more-text {
  position: absolute;
  right: 10px;
  bottom: 10px;
  padding: 2px 6px;
  border-radius: 4px;
  background-color: rgb(67, 54, 106);
  color: white;
  transition: opacity 0.3s;
  pointer-events: none;
}

/* .pricing-card:hover .see-more-text{
opacity: 1;
} */

.pricing-card.scrolled .see-more-text {
  opacity: 0;
}
`, "",{"version":3,"sources":["webpack://./src/components/PricingModel.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,uBAAuB;AACzB;;;;AAIA;EACE,cAAc;EACd,kBAAkB;EAClB,aAAa;EACb,kBAAkB;EAClB,gBAAgB;EAChB,aAAa;EACb,eAAe;EACf,wCAAwC;EACxC,sDAAsD;EACtD,4BAA4B;;EAE5B,qBAAqB;;AAEvB;;AAEA;EACE,QAAQ;AACV;;AAEA;;GAEG;;AAEH;;GAEG;;AAEH;EACE,oCAAoC;EACpC,kBAAkB;AACpB;;;AAGA;EACE,kBAAkB;EAClB,gBAAgB;AAClB;;;AAGA;EACE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,WAAW;EACX,YAAY;EACZ,2EAA2E;EAC3E,oBAAoB;EACpB,6BAA6B;AAC/B;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;EAClB,kCAAkC;EAClC,YAAY;EACZ,wBAAwB;EACxB,oBAAoB;AACtB;;AAEA;;GAEG;;AAEH;EACE,UAAU;AACZ","sourcesContent":[".modal-header {\n  display: flex;\n  justify-content: center;\n}\n\n\n\n.pricing-card {\n  width: '18rem';\n  border-radius: 8px;\n  height: 250px;\n  position: relative;\n  overflow-y: auto;\n  padding: 16px;\n  cursor: pointer;\n  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);\n  background: linear-gradient(to bottom, #aacedd, white);\n  transition: height 0.3s ease;\n\n  scrollbar-width: none;\n\n}\n\n.pricing-card::-webkit-scrollbar {\n  width: 0;\n}\n\n/* .pricing-card:hover{\n  scrollbar-width: thin;\n} */\n\n/* .pricing-card:hover::webkit-scrollbar{\n  width: 6px;\n} */\n\n.pricing-card:hover::-webkit-scrollbar-thumb {\n  background-color: rgba(0, 0, 0, 0.3);\n  border-radius: 4px;\n}\n\n\n.price-details {\n  position: relative;\n  overflow: hidden;\n}\n\n\n.pricing-card::after {\n  content: '';\n  position: absolute;\n  bottom: 0;\n  left: 0;\n  width: 100%;\n  height: 40px;\n  background: linear-gradient(to bottom, transparent, rgba(255, 255, 255, 1));\n  pointer-events: none;\n  transition: opacity 0.2s ease;\n}\n\n.pricing-card.scrolled::after {\n  opacity: 0;\n}\n\n.see-more-text {\n  position: absolute;\n  right: 10px;\n  bottom: 10px;\n  padding: 2px 6px;\n  border-radius: 4px;\n  background-color: rgb(67, 54, 106);\n  color: white;\n  transition: opacity 0.3s;\n  pointer-events: none;\n}\n\n/* .pricing-card:hover .see-more-text{\nopacity: 1;\n} */\n\n.pricing-card.scrolled .see-more-text {\n  opacity: 0;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
